import { HIDDEN_CUSTOM_FIELDS } from 'src/entities/products/CustomField';

export default class CustomFieldOrderProduct {
    fieldName: string;
    localizedName: string;
    value: string;
    options?: Record<string, string>;
    id?: number;
    orderProductId?: number;

    constructor(json: any) {
        this.fieldName = json.fieldName;
        this.localizedName = json.localizedName;
        this.value = json.value;
        this.options = json.options;
        this.id = json.id;
        this.orderProductId = json.orderProductId;
    }

    public get hidden(): boolean {
        return HIDDEN_CUSTOM_FIELDS.includes(this.fieldName);
    }
}
